import React, { useEffect } from 'react'
import ReactAudioPlayer from 'react-audio-player'
import { Link } from 'react-router-dom'
import { API_URL } from './config'
import './Cancelled.css'
import './Success.css'

const Success = () => {
  const isBusiness = !!localStorage.getItem('businessid')
  const nextPath = isBusiness ? '/dashboard' : '/tickets'
  const nextLabel = isBusiness ? 'Go to dashboard' : 'Go to your ticket'

  // Keep the original guard against accidental refresh / leaving the page,
  // but attach once and clean up on unmount.
  useEffect(() => {
    window.onbeforeunload = () => false

    const onKeyDown = (event) => {
      switch (event.keyCode) {
        case 116: // F5
        case 17: // Ctrl
        case 82: // R
          event.preventDefault()
          break
        default:
          break
      }
    }

    document.addEventListener('keydown', onKeyDown)
    return () => {
      window.onbeforeunload = null
      document.removeEventListener('keydown', onKeyDown)
    }
  }, [])

  return (
    <div className="cx-page">
      <div style={{ display: 'none' }}>
        <ReactAudioPlayer src={`${API_URL}/apps/kscanner/success.mp3`} autoPlay controls />
      </div>

      <div className="cx-card" role="status" aria-live="polite">
        <div className="cx-icon cx-icon--good">
          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path className="cx-check" d="M5 12.5l4.5 4.5L19 7.5" />
          </svg>
        </div>

        <h1 className="cx-title">Payment successful</h1>
        <p className="cx-text">
          Thank you! Your payment has been processed successfully.
          <br />A receipt is on its way to your email.
        </p>

        <Link to={nextPath} className="cx-btn cx-btn--good">
          {nextLabel}
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M5 12h14M13 6l6 6-6 6" />
          </svg>
        </Link>
      </div>
    </div>
  )
}

export default Success
